export default {"src":"/_next/static/media/logo-icon-light.57ee2970.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};